import {
    RiBookmark2Line,
} from "@remixicon/react";
import React from "react";
import {
    Article,
    GetArticleDocument,
    ListArticleVersionsDocument,
    useUnpublishArticleMutation,
} from "../../../__generated__/api";
import { useConfirm } from "../../../components/confirm/Confirm";
import Dropdown from "../../../components/theme/dropdown/Dropdown";
import Icon from "../../../components/theme/icon/Icon";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

export default function UnpublishButton({
    article,
    onClick,
}: {
    article: Article | undefined | null,
    onClick?: () => void
}) {
    const [unpublish] = useUnpublishArticleMutation();

    const { element: publishElement, setShouldShow: setShowPublish } = useConfirm({
        title: "Unpublish",
        confirmText: "Unpublish",
        closeText: "Cancel",
        confirmMetricPath: [LoggingHandler.Metrics.ARTICLES, "unpublish"],
        onConfirm: async () => {
            await unpublish({
                refetchQueries: [
                    { query: GetArticleDocument, variables: { id: article?.id } },
                    { query: ListArticleVersionsDocument, variables: { id: article?.id } },
                ],
                variables: {
                    id: article?.id,
                },
            });
        },
        body: `By unpublishing this article, it will no longer be visible to users. `
        + `Are you sure you want to unpublish this article?`,
    });
    if (!article?.publishedDate) {
        return null;
    }

    return (
        <>
            {publishElement}
            <Dropdown.Item
                onClick={() => {
                    setShowPublish(true);
                    onClick?.();
                }}
                prefixIcon={<Icon icon={<RiBookmark2Line />} />}
            >
                Unpublish
            </Dropdown.Item>
        </>
    );
}

UnpublishButton.defaultProps = {
    onClick: undefined,
};
